<template>
  <div>
    <v-container>
      <v-form ref="form">
        <v-row>
          <v-col>
            <h2 class="pb-5">{{ this.pageTitle }}</h2>
          </v-col>
        </v-row>

        <v-container
          id="scroll-target"
          class="custom-form overflow-y-auto px-5"
        >
        <v-row>
          <v-col cols="4" sm="4" class="pb-n5 mt-n6 pt-6">
            <v-autocomplete
              outlined
              :label="this.$t('payrollprocessrun.payout')"
              type="text"
              :rules="[rules.required]"
              :items="payoutctrlList"
              v-model="formData.payoutctrlid"
              @change="changePayout(formData.payoutctrlid)"
              dense
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="8" sm="8" class="pb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('statutoryexportcommonused.payoutdescription')"
              type="text"
              v-model="payoutdesc"
              readonly
              background-color="#ffeab2"
              dense
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="2" sm="2" class="pb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('statutoryexportcommonused.payoutyear')"
              type="number"
              v-model="pyyear"
              readonly
              background-color="#ffeab2"
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="2" sm="2" class="pb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('statutoryexportcommonused.payoutmonth')"
              type="number"
              v-model="pymonth"
              readonly
              background-color="#ffeab2"
              dense
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="8" sm="8" class="pb-n5 mt-n8">
            <v-text-field
              outlined
              :label="this.$t('postpayroll.payrollgroupdescription')"
              type="text"
              v-model="grouppdesc"
              readonly
              background-color="#ffeab2"
              dense
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="4" sm="4" class="pb-n5 mt-n8">
            <v-autocomplete
              outlined
              :label="$t('latenessdeduction.payitem')"
              type="text"
              :rules="[rules.required]"
              :items="payitemctrlList"
              v-model="formData.payitemctrlid"
              @change="changePayItem(formData.payitemctrlid)"
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="4" sm="4" class="pb-n5 mt-n8">
            <v-text-field
              outlined
              :label="$t('latenessdeduction.payitemcode')"
              type="text"
              v-model="payitemcode"
              readonly
              background-color="#ffeab2"
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <div class="btn-process" style="margin-right: 70px;">
            <v-btn color="primary" style="width: 150px" @click="onPost">
              {{$t('button.post')}}
            </v-btn>
          </div>

          <div class="btn-process">
            <v-btn color="primary" style="width: 150px" @click="onUnPost">
              {{$t('button.undoposting')}}
            </v-btn>
          </div>
        </v-row>
      </v-container>
      </v-form>
    </v-container>

    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import ErrorDialog from "../../../components/common/ErrorDialog";
import "vue-loading-overlay/dist/vue-loading.css";


export default {

  components: {
    "app-error": ErrorDialog,
  },

  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('reportsparam.required'),
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t('reportsparam.invalidemail');
        },
      },
      // pageTitle: "Performance Reward Posting to Payroll",

      formData: {
        payoutctrlid: null,
        payoutstartdate: null,
        payoutenddate: null,
        payoutcurrencyid: null,
        payitemctrlid: null,  
        userid: this.$store.getters.userId,
      },

      payoutctrls: [],
      payoutctrlList: [],

      payoutdesc: "",
      pymonth: "",
      pyyear: "",
      grouppdesc: "",
      errMsg: "",
      isErr: false,
      loading: true,

      payitem: [],
      payitemctrlList: [],
      payitemcode: null,
    };
  },

  computed: {
    pageTitle() {
        return this.$t('pmrewardposting.performancerewardpostingtopayroll');
    }
  },

  methods: {

    onUnPost() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }

      if ((this.$refs.form.validate())){
      this.$store.dispatch('post', {url: "/reward/bonuspostingundo", payload: this.formData})
        .then((res) => {
          let dataholder = res.data.rec;

          if (res.data.status != 409) {
            let item = {
              processedCount: dataholder.unposted,
              staffprocessedCount: dataholder.staffprocess,
              totalUnPosted: dataholder.unposted,
            }
          
            this.$router.push({ name: "pmrewardbonuspostinglog", params: { item } });
          } else {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
      }
    },

    onPost() {
      const vm = this;

      if ((this.$refs.form.validate())){
      console.log('formData', this.formData)
      this.$store.dispatch('post', {url: "/reward/bonusposting", payload: this.formData})
        .then((res) => {
          let dataholder = res.data.rec;
          console.log('res', res.data);

          if (res.data.status != 409) {
            let item = {
              processedCount: dataholder.posted,
              staffprocessedCount: dataholder.staffprocess,
              totalPosted: dataholder.posted,
            }
            this.$router.push({ name: "pmrewardbonuspostinglog", params: { item } });
          } else {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          }
          
        })
        .catch((err) => {
          console.log('err', err)
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
      }
    },

    getPayItemRecords() {
      const vm = this;

      this.$store.dispatch('get', {url: "/reward/payitem"})
        .then((res) => {
          vm.payitem = res.data.rec;

          for (let i = 0; i < vm.payitem.length; i++) {
            vm.payitemctrlList.push({
              text: vm.payitem[i].payitemdesc,
              code: vm.payitem[i].payitemcode,
              value: vm.payitem[i].id,
            });
          }

          vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },

    changePayItem(id) {
      let item = this.payitemctrlList.find((item) => item.value == id);
      this.payitemcode = item.code;
    },

    getPayoutRecords() {
      const vm = this;

      this.$store.dispatch('get', {url: "/payoutrecord/all"})
        .then((res) => {
          vm.payoutctrls = res.data.rec;

          for (let i = 0; i < vm.payoutctrls.length; i++) {
            vm.payoutctrlList.push({
              text: vm.payoutctrls[i].payoutcode,
              startdate: vm.payoutctrls[i].startdate,
              enddate: vm.payoutctrls[i].enddate,
              value: vm.payoutctrls[i].id,
            });
          }

          vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },

    changePayout(id) {
      let item = this.payoutctrls.find((item) => item.id == id);

      this.payoutcode = item.payoutcode;
      this.payoutdesc = item.payoutdesc;
      this.formData.payoutstartdate = moment(item.startdate).format("YYYY-MM-DD");
      this.formData.payoutenddate = moment(item.enddate).format("YYYY-MM-DD");
      this.formData.payoutcurrencyid = item.pycrcyid;
      //for testing only
      // this.formData.payoutstartdate = "2025-05-01";
      // this.formData.payoutenddate = "2025-05-31";
      this.pyyear = item.pyyear;
      this.pymonth = item.pymonth;
      this.grouppdesc = item.grouppdesc;

      // this.getLeaveRecordUpToDate(id)
    },
  },

  mounted() {
    this.getPayoutRecords();
    this.getPayItemRecords();
  },
};
</script>

<style scoped>
.btn-process {
  margin-right: 120px;
  width: 100px;
}
</style>